module.exports = function UpdateTopicSetRequest(path, bytes) {
    this.path = path;
    this.bytes = bytes;
};




//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/update-topic/update-topic-set-request.js
// module id = 511
// module chunks = 0